import React from 'react';

const Unauthorized = ({ withMenu = false }) => {
  const content = (
    <div style={{ textAlign: 'center', padding: '48px 16px', color: '#495057' }}>
      <div style={{ fontSize: 40, marginBottom: 8 }}>🔒</div>
      <h4>Accès refusé</h4>
      <p className="text-muted mb-0">
        Vous n'avez pas l'autorisation d'accéder à cette page.
        {withMenu ? ' Utilisez le menu ci-dessus pour accéder à vos onglets autorisés.' : ''}
      </p>
    </div>
  );
  return content;
};

export default Unauthorized;